import React from "react";
import { Spinner } from 'react-bootstrap';

export default function ExamplePost() {
    let [data, setData] = React.useState('');
    let [loading, enable] = React.useState(false);

    const onClickButton = () => {
        enable(true);
        const body = {
            login: 'admin',
            password: '1234'
        };
        fetch('/user/create', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json'}
        }).then(response =>{
            return response.json()
        }).then(result => {
            enable(false);
            setData(result)
        }).catch(err => {
            alert(err)
        })
    };

    return (
    <>
        <main>
            <h1>Test Post From API</h1>
            <button type="button" className="btn btn-primary" onClick={onClickButton}>Click Post</button>
            <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" className={loading ? 'd-inline-block' : 'd-none'} />
            <div className="mt-3">TEST POST : Login {data.login}, Password : {data.password}</div>
        </main>
    </>
    );
} 